import React from "react";
import ToggleButton from "@material-ui/lab/ToggleButton";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import DoneAllIcon from "@material-ui/icons/DoneAll";
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import CancelIcon from "@material-ui/icons/Cancel";
import ListAltIcon from "@material-ui/icons/ListAlt";
import "../styles/toggleButtonGroup.scss";

const useStyles = makeStyles({
  ToggleButtonGroup: {
    background: "rgba(255, 237, 246, 1)",
  },

  toggleButton: {
    textTransform: "none",
    color: "rgba(245, 54, 137, .93)",
    padding: "5px 11px 5px 11px",
    backgroundColor: "white",
    fontFamily: "Inter",
    border: "1px solid rgba(243, 179, 207, .6)",
    borderRight: "1px solid rgba(243, 179, 207, .6)",
    marginRight: 1,

    "&.Mui-selected": {
      backgroundColor: "rgba(243, 179, 207, .6)",
      color: "rgba(245, 54, 137, .93)",
      "&:hover": {
        backgroundColor: "rgba(243, 179, 207, .8)",
      },
    },
    "&:hover": {
      backgroundColor: "rgba(243, 179, 207, .8)",
    },
  },
});

export default function ToggleButtonsTrasnferList({ alignment, setAlignment }) {
  const classes = useStyles();

  const handleAlignment = (event, newAlignment) => {
    setAlignment(newAlignment);
  };

  return (
    <ToggleButtonGroup
      value={alignment}
      exclusive
      onChange={handleAlignment}
      aria-label="text alignment"
    >
      <ToggleButton
        value="ALL"
        aria-label="left aligned"
        className={classes.toggleButton}
        style={{ borderRadius: "20px 0px 0px 20px" }}
      >
        {" "}
        {alignment === "ALL" && (
          <ListAltIcon style={{ fontSize: 14, marginRight: 5 }} />
        )}
        All
      </ToggleButton>
      <ToggleButton
        value="REQ_SUBMITTED"
        aria-label="left aligned"
        className={classes.toggleButton}
      >
        {alignment === "REQ_SUBMITTED" && (
          <AccessTimeIcon style={{ fontSize: 14, marginRight: 5 }} />
        )}
        Pending
      </ToggleButton>
      <ToggleButton
        value="REQ_APPROVED"
        aria-label="centered"
        className={classes.toggleButton}
      >
        {alignment === "REQ_APPROVED" && (
          <DoneAllIcon style={{ fontSize: 14, marginRight: 5 }} />
        )}
        Approved
      </ToggleButton>
      <ToggleButton
        value="REQ_DENIED"
        aria-label="right aligned"
        className={classes.toggleButton}
        style={{ borderRadius: "0px 20px 20px 0px" }}
      >
        {alignment === "REQ_DENIED" && (
          <CancelIcon style={{ fontSize: 14, marginRight: 5 }} />
        )}
        Rejected
      </ToggleButton>
    </ToggleButtonGroup>
  );
}
